export default __webpack_public_path__ + "static/media/calendar.87e0e7ca.svg";